import { useState } from 'react'
import { ZendeskTicketPayload } from 'types/Zendesk'
import Api from 'services/api'

const useZendeskTicket = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  async function sendTicket (payload: ZendeskTicketPayload) {
    setLoading(true)
    setError(false)
    setSuccess(false)
    try {
      await Api.Zendesk.create(payload)
      setSuccess(true)
    } catch {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return { sendTicket, loading, error, success, setSuccess }
}

export default useZendeskTicket
